import { RefObject, useCallback, useEffect, useState } from "react";
import { MessagesService } from "../../../../../services/messages";
import { IMessage } from "../../../types/Message";

export const useLazyLoad = (
  conversationId: string | undefined,
  scrollContainer: RefObject<HTMLDivElement>,
  setData: React.Dispatch<React.SetStateAction<IMessage[]>>,
  setCanLoadMore: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [prevScroll, setPrevScroll] = useState<number>(0);

  const [request, setRequest] = useState<any>({
    take: 50,
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const load = useCallback(async () => {
    try {
      setIsLoading(true);

      const res: any = await MessagesService.fetchMessages(
        request,
        conversationId || ""
      );

      res.length === 0 && setCanLoadMore(false);

      const { current } = scrollContainer;

      setPrevScroll(current ? current.scrollHeight : 0);

      setData((prev) => [...res, ...prev]);

      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  }, [conversationId, request, setData, scrollContainer, setCanLoadMore]);

  useEffect(() => {
    if (!isLoading && scrollContainer) {
      const { current } = scrollContainer;

      if (current) {
        current.scrollTop = current.scrollHeight - prevScroll;
      }
    }
  }, [isLoading, prevScroll, scrollContainer]);

  useEffect(() => {
    request.skip && load();
  }, [load, request]);

  return { isLoading, setRequest };
};
